var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333496 7.50004C0.333496 3.81814 3.31826 0.833374 7.00016 0.833374C10.682 0.833374 13.6668 3.81814 13.6668 7.50004C13.6668 11.1819 10.682 14.1667 7.00016 14.1667C3.31826 14.1667 0.333496 11.1819 0.333496 7.50004ZM9.47156 6.63811C9.73189 6.37777 9.73189 5.95565 9.47156 5.6953C9.21123 5.43495 8.78909 5.43495 8.52876 5.6953L6.33349 7.89057L5.47157 7.02864C5.21122 6.76831 4.78911 6.76831 4.52875 7.02864C4.26841 7.28897 4.26841 7.71111 4.52875 7.97144L5.86209 9.30477C6.12243 9.56511 6.54456 9.56511 6.80489 9.30477L9.47156 6.63811Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTick);
export default __webpack_public_path__ + "static/media/whiteTick.af4a62b6edc32761bef7baf2e7cf88ee.svg";
export { ForwardRef as ReactComponent };